export default "/images/bg-analytics.svg?0f89520cc3d139fac1c723014f4a9533";